<af-main-container [title]="'i18n_lib_breadcrumb#ClassificationFraud' | translate"
                   [showBreadcrumbs]="true"
                   [showBackButton]="false"
                   spinnerIds="initial"
                   [buttonDisabled]="isExporting"
                   [tabPathToTab]="tabPathToTab"
                   (buttonClickListener)="downloadExport()"
                   [buttonLabel]="'i18n_af_buttonDownloadReport' | translate">
    <div class="w-100 h-100 mt-24" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
        <af-warning-panel warningText="i18n_af_warningPanelClassification"
                          buttonLabel="i18n_af_buttonDocumentation"
                          (clickListener)="downloadDocument()"/>
        <af-classification-matrix (openDetails)="openDetails($event)"
                                  [hasChips]="true"
                                  (selectTypeListener)="selectedType = $event"/>
    </div>
</af-main-container>
